var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.25 14.141"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 172",
    d: "M11.567 13.901L.244 2.576A.77.77 0 010 2.017a.768.768 0 01.244-.559L1.459.243a.766.766 0 01.559-.242.763.763 0 01.557.242l9.551 9.55 9.55-9.55a.763.763 0 01.558-.242.763.763 0 01.559.242l1.215 1.215a.766.766 0 01.242.559.768.768 0 01-.242.559L12.685 13.901a.766.766 0 01-1.118 0",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "7de2d376feeda9b17a4a90a0b5d20733.svg";
export { SvgCarouselArrowDown as ReactComponent };